const HOST = `https://arbitr-parser-api.fullstack-freelancer.ru`;
const APP_URL = `https://arbitr-paser.fullstack-freelancer.ru`;
export { HOST, APP_URL }
